import { render, staticRenderFns } from "./GameStart.vue?vue&type=template&id=1719d98c&"
import script from "./GameStart.vue?vue&type=script&lang=js&"
export * from "./GameStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports